// extracted by mini-css-extract-plugin
export default {"Question":"Question_Question__zDbbz"};